export default {
  home: {
    sections: {
      trendingParlays: "Combinadas populares del día",
    },
    checkout: {
      placeItOn: "Apuesta en",
    },
    matchups: {
      today: "Enfrentamientos de hoy",
      thisWeek: "Enfrentamientos de esta semana",
      upcoming: "Próximos enfrentamientos",
    },
    actions: {
      claimNow: "Reclamar ahora",
      showMore: "Mostrar más",
      showLess: "Mostrar menos",
    },
    empty: {
      parlayMinGames: "Todavía no hay tendencias disponibles. Se necesitan al menos 3 juegos.",
    },
    hundredPercentClub: {
      subtitle: "Props que acertaron en el 100% de los juegos",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Encuentra valor cuando cambian las alineaciones iniciales. Incluido con",
        injuryImpact: "Mira cómo las lesiones afectan a sus compañeros. Incluido con",
        opponentRank: "Aprovecha enfrentamientos defensivos favorables. Incluido con",
        startingPitchers: "Busca oportunidades contra lanzadores vulnerables. Incluido con",
        weatherReport: "Usa el viento y el clima a tu favor. Incluido con",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Cargando mercados...",
        loadError: "No se pudieron cargar los mercados.",
      },
    },
    sidebar: {
      downloadApp: "Descarga la app",
      neverMissTrend: "No te pierdas ninguna tendencia",
      unlockAnalysis: "Desbloquea el análisis completo",
      unlock: "Desbloquear",
      mostBetOn: "Más apostados",
      mostSearched: "Más buscados",
      trendingLeagues: "Ligas populares",
      topOffers: "Lo mejor de {{type}}",
      newsletter: {
        title: "Adelántate a las tendencias",
        description: "Únete a <strong>más de 30.000 apostadores deportivos</strong> que reciben análisis y ofertas de Linemate en su correo.",
        subscribe: "Suscribirse",
        subscribedTitle: "¡Ya estás suscrito!",
        subscribedBody: "Te enviaremos las últimas tendencias y ofertas de Linemate a tu correo.",
      },
      improveExperience: "Mejora tu experiencia con Linemate",
      getAccess: "OBTÉN ACCESO A JUGADAS AVANZADAS Y ANÁLISIS MÁS PROFUNDOS",
    },
  },
};
